import React from 'react';

import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MobileStepper,
  Typography,
  styled,
} from '@mui/material';

import { IProductCarouselPoint } from '../../../../types/IProductCarousel';

export interface IProductModal {
  open: boolean;
  onClose: () => void;
  content: any;
  title: string;
}

const Image = styled('img')(() => ({
  width: '100%',
}));
const Point = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: '10px',
}));
const PointsNumber = styled('div')(({ theme }: any) => ({
  width: '36px',
  height: '36px',
  display: 'flex',
  flex: 'none',
  borderRadius: '2000px',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '15px',
  color: 'white',
  marginRight: '10px',
  background: theme.palette.primary.main,
}));

const ProductModal = (props: IProductModal) => {
  const { title, content, onClose, open } = props;

  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = content.steps.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Dialog
      sx={{
        width: '100%',
        '.MuiBackdrop-root': {
          backgroundColor: 'rgb(255 255 255 / 90%)',
        },
        '& .MuiDialog-container': {
          alignItems: 'flex-start',
        },
      }}
      maxWidth='xl'
      open={open}
      scroll={'paper'}
      onClose={(_, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          onClose;
        }
      }}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <Grid container>
          <Grid xs={12} md={8} item>
            <Image
              src={content.steps[activeStep].imageUrl}
              alt={content.steps[activeStep].title}
            />
          </Grid>
          <Grid xs={12} md={4} item>
            <Box sx={{ padding: '10px 20px' }}>
              <Typography variant='h5' color='primary' sx={{ marginBottom: 3 }}>
                {content.steps[activeStep].title}
              </Typography>

              {content.steps[activeStep].points.map(
                (item: IProductCarouselPoint, index: number) => (
                  <Point key={index}>
                    {content.steps[activeStep].points.length > 1 && (
                      <PointsNumber>{index + 1}</PointsNumber>
                    )}
                    <Box>
                      <Typography sx={{ fontWeight: 'bold' }}>
                        {item.title}
                      </Typography>
                      <Typography>{item.description}</Typography>
                    </Box>
                  </Point>
                )
              )}
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Box></Box>
        <MobileStepper
          steps={maxSteps}
          position='static'
          activeStep={activeStep}
          nextButton={
            <IconButton
              onClick={handleNext}
              disabled={activeStep === maxSteps - 1}>
              <KeyboardArrowRight fontSize='large' />
            </IconButton>
          }
          backButton={
            <IconButton onClick={handleBack} disabled={activeStep === 0}>
              <KeyboardArrowLeft fontSize='large' />
            </IconButton>
          }
        />
        <Button
          onClick={onClose}
          variant={activeStep >= maxSteps - 1 ? 'contained' : 'outlined'}>
          {activeStep >= maxSteps - 1 ? 'Continue' : 'Skip'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProductModal;
